module.exports = __webpack_public_path__ + "img/628.a6abf9f9.png";